import qs from 'qs';
import { network } from 'services/network';

import { QueryParams } from 'api/queries/getStoredFilterBulkAssignOrRemoveTags.query';

export const getStoredFilterBulkAssignOrRemoveTags = ({ contractId }: QueryParams) => {
    const querystring = qs.stringify({ contractId }, { addQueryPrefix: true, skipNulls: true });
    const url = `api/bo/getStoredFilterBulkAssignOrRemoveTags${querystring}`;
    return network.get(url).then((response) => {
        return response.data;
    });
};
